import Link from 'next/link';
import { useRouter } from 'next/router';
import React from 'react';
import { withTranslation } from 'next-i18next';
import { getClassName } from '../../../nav-helpr';

const TutorHeaderDesktopLeftPart = ({ t }) => {
  const { pathname: currentPath } = useRouter();
  return (
    <div className="hidden md:ml-6 md:flex md:space-x-8">
      {/* Current: "border-indigo-500 text-gray-900", Default: "border-transparent text-default hover:border hover:text-gray-700" */}
      <Link legacyBehavior href="/t/dashboard">
        <a className={getClassName('/t/dashboard', currentPath)}>
          {t('service.header.dashboard')}
        </a>
      </Link>
      <Link legacyBehavior href="/t/materials">
        <a className={getClassName('/t/materials', currentPath)}>
          {t('service.header.materials')}
        </a>
      </Link>
    </div>
  );
};

const wrapped = withTranslation('common')(TutorHeaderDesktopLeftPart);

export default wrapped;
